import React from 'react';
import i2 from "./2.webp";
import i4 from "./4.webp";
import i5 from "./5.webp";
import i6 from "./6.webp";
import "./Contact.css";


import Section from '../../../HOC/Section';

const contact = () => {
  const mapsUrl = 'https://share.google/wj8How7D9GaZvJJha';
  const instagramUrl = 'https://www.instagram.com/goldnar.guzellik.salonu/';
  const facebookUrl ='https://www.facebook.com/profile.php?id=61589478787993';

  return (
    <Section id='contact'>
      <div className='container pt-2 pb-5'>
        <div className='section-header pt-5 pb-5 text-center'>
          <h3 className='section-title'>
            <span>Bizimle </span>İletişime Geçin
          </h3>
          <h6 className='section-subtitle mr-auto ml-auto'>
          </h6>
        </div>
        <div className='section-content'>
          <div className='row'>
            <div className='col-md-9 col-lg-7 mr-auto ml-auto'>
              <form>
                <div className='form-group'>
                  <input
                    type='text'
                    className='form-control rounded-0'
                    aria-describedby='emailHelp'
                    placeholder='İsminizi giriniz...'
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='email'
                    className='form-control rounded-0'
                    aria-describedby='emailHelp'
                    placeholder='Emailinizi giriniz...'
                  />
                </div>
                <div className='form-group'>
                  <textarea
                    className='form-control rounded-0'
                    rows='5'
                    placeholder='Mesajınızı giriniz...'
                  />
                </div>
                <div className='form-group text-center'>
                  <button className='btn btn-block btn-primary rounded-0 mr-auto ml-auto'>
                    Gönder
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

      <div className="row">
       
      <div className="col-lg-3s col-md-3 col-sm-12 col-12 p-5">
        <a
          href={mapsUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={i2} className="contactIcons" title="Konum için tıklayınız" alt="Konum" />
        </a>
        <p className="contactText">
        <span><b>Konum:</b></span><br/>
          Atatürk Mah. 357. Sk. No:2 İç Kapı No:301<br/>
          Merkez / Erzincan 24100, Türkiye
        </p>
      </div>
      
      <div className="col-lg-3s col-md-3 col-sm-12 col-12 p-5">
      <a href="tel:+905433012423">
          <img src={i4} className="contactIcons" title="Telefonla arayın" alt="Telefon" />
        </a>
        <p className="contactText">
        <span><b>Telefon:</b></span><br/>
          <a href="tel:+905433012423">+90 543 301 24 23</a>
        </p>
      </div>
      <div className="col-lg-3s col-md-3 col-sm-12 col-12 p-5">
        <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
          <img src={i5} className="contactIcons" title="Instagram için tıklayınız" alt="Instagram" />
        </a>
        <p className="contactText">
        <span><b>Instagram:</b></span><br/>
          <a href={instagramUrl} target="_blank" rel="noopener noreferrer">@goldnar.guzellik.salonu</a>
        </p>
      </div>
      <div className="col-lg-3s col-md-3 col-sm-12 col-12 p-5">
        <a href={facebookUrl} target="_blank" rel="noopener noreferrer">
          <img src={i6} className="contactIcons" title="İşletme profili için tıklayınız" alt="İşletme profili" />
        </a>
        <p className="contactText">
        <span><b>Facebook:</b></span><br/>
        @goldnar.guzellik.salonu
        </p>
      </div>
      </div>
      </div>

     
    </Section>
  );
};

export default contact;
